var exports = {
  "gB": "developmentSectionContainer__Qd5ZJI",
  "Ug": "developmentHelpText__988LHi",
  "sL": "developmentActionList__cuclrb",
};

module.exports = exports;
